// useLogout.ts
import { useNavigate } from "react-router-dom";
import { logout } from "../api";
import { useCallback, useState } from "react";

export const useLogout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const initiateLogout = useCallback(() => {
    setIsLoggingOut(true);
  }, []);

  const completeLogout = useCallback(async () => {
    if (isLoggingOut) {
      await logout();
      setIsLoggingOut(false);
    }
  }, [isLoggingOut, navigate]);

  const cancelLogout = useCallback(() => {
    setIsLoggingOut(false);
  }, []);

  return { initiateLogout, completeLogout, cancelLogout, isLoggingOut };
};
